import http from "./http";
import { baseUrls } from '@/utils/baseUrlConfig';
const shop_url = baseUrls.shop_url;
const lottery_url = baseUrls.lottery_url;
const user_url = baseUrls.user_url;
const score_url = baseUrls.score_url;


//这里引入http在这里可以接收请求地址请求方式以及参数
export function req_user({method='get', url='', baseURL= user_url, params={}, headers={}}){
    //把api返回出去
    return http({
        method,
        url,
        baseURL,
        params,
        headers,
    })
}
export function req_score({method='get', url='', baseURL= score_url, params={}, headers={}}){
  return http({
      method,
      url,
      baseURL,
      params,
      headers,
  })
}
export function req_shop({method='get', type='', baseURL= shop_url, params={}}){
  let url = baseURL + JSON.stringify({ type: type, json: JSON.stringify(params) });
  return http({
      method,
      url,
  })
}
export function req_ltry({method='get', type='',baseURL= lottery_url, params={}}){
  let url = baseURL + JSON.stringify({ type: type, json: JSON.stringify(params) });
  return http({
      method,
      url,
  })
}
export function req_hd({method='get', url='', baseURL= '', params={}, headers={}}){
  return http({
      method,
      url,
      baseURL,
      params,
      headers
  })
}



// WEBPACK FOOTER //
// ./src/utils/api.js